import React from 'react';
import { useSEOTableConfig } from './useSEOTableConfig';
import { HeadContainer, HeadRow } from './Head.styles';
import Cell from './Cell';

const Head = (): JSX.Element => {
  const { getTemplateColumnsSet, head, firstColumnCustomWidth, columnCount } = useSEOTableConfig();
  const templateColumns = getTemplateColumnsSet(firstColumnCustomWidth, columnCount);

  return (
    <HeadContainer>
      <HeadRow style={{ gridTemplateColumns: templateColumns }}>
        <Cell isEmpty />
        {head.map((item, index) => (
          <Cell
            key={index}
            text={item}
            isHead
          />
        ))}
      </HeadRow>
    </HeadContainer>
  );
};

export default Head;
